import {notify} from "notiwind"

export const useNotification = () => {
    const showNotification = ( title, text) => {
        const config = {
            title,
            text
        }

        notify(config, 4000);
    };

    const showSuccess = (text) => showNotification("Success",  text);
    const showError = (text) => showNotification("Error",  text);

    return {
        showNotification,
        showSuccess,
        showError
    }
}